(ns practitest.frontend.search.subs
  (:require
   [clojure.string          :as string]
   [re-frame.core           :as re-frame]
   [practitest.frontend.common-old-fe.logging :as log]))

(def entity-mapping {"qtest_design" "Test"
                     "suite"        "TestSet"
                     "et"           "ET"
                     "issue"        "Issue"
                     "requirement"  "Requirement"})

(defn map-entity-name [entity-name]
  (get entity-mapping entity-name entity-name))

(defn map-user-name [users id f_name]
  (if id
    (if (= f_name "assigned_to_id")
      (get users id "[Removed User]")
      (get users (str (str "User-") id) "[Removed User]"))
    ""))

(re-frame/reg-sub
  :search/init-complete?
  (fn [db _]
    (:init-complete? db)))

(re-frame/reg-sub
 :search/results-total
 (fn [db _]
   (:total db)))

(re-frame/reg-sub
 :search/query
 (fn [db _]
   (get-in db [:query-state :query])))

(re-frame/reg-sub
  :search/didyoumean
  (fn [db _]
    (:didyoumean db)))

(re-frame/reg-sub
 :search/users
 (fn [db _]
   (:search-users db)))

(re-frame/reg-sub
 :search/filters
 (fn [db _]
   (get-in db [:query-state :filters])))

(re-frame/reg-sub
 :search/users-map
 (fn [db _]
   (into {} (map (juxt :id :name) (:search-users db)))))

(defn- display-id-workaround
  [result]
  ;; override display_id for `entity2` (which is used in other places of search results)
  ;; with display_id from `entity` (which has correct display_id)
  ;; decided to solve it here to avoid any breaking changes, not sure where this entity2 is used
  (update result :entity2
          assoc :display_id (:display_id (first (vals (:entity result))))))

(re-frame/reg-sub
 :search/results-table
 (fn [db _]
   (map display-id-workaround (:results db))))

(re-frame/reg-sub
 :search/facet-list
 (fn [{:keys [facets total]} _]
   (let [users (re-frame/subscribe [:search/users-map])]
     (->> facets
          ;(remove
           ;(fn [{:keys [values]}]
           ;  ;; facets that only have one value
           ;  ;; and cover the whole result set
           ;  ;; dont contribute any information
           ;  (and (= 1 (count values))
           ;       (= total (last (first values))))))
          (remove
           (fn [{:keys [facet_id field_display_name]}]
             ;; id equals to display name only if the
             ;; custom field was deleted from the project
             (and (string/starts-with? facet_id "___f_")
                  (= facet_id field_display_name))))
          (map
           (fn [facet]
             (update facet :values
                     (fn [values]
                       (map (fn [[v c]]
                              [v
                               (cond
                                 (= "___type" (:facet_id facet)) (map-entity-name v)
                                 (:is_user facet)                (map-user-name @users v (:facet_id facet))
                                 :else                           v)
                               c])
                            values)))))))))

(re-frame/reg-sub
 :search/is-searching
 (fn [db _]
   (:searching? db)))

(re-frame/reg-sub
 :search/per-page
 (fn [db _]
   (get-in db [:query-state :per_page])))

(re-frame/reg-sub
 :search/current-page
 (fn [db _]
   (get-in db [:query-state :page])))

(re-frame/reg-sub
 :search/total-pages
 (fn [db _]
   (let  [total (re-frame/subscribe [:search/results-total])
          per-page (re-frame/subscribe [:search/per-page])]
     (Math/ceil (/ @total @per-page)))))

(re-frame/reg-sub
 :search/pages
 (fn [db _]
   (let [current-page (re-frame/subscribe [:search/current-page])
         total        (re-frame/subscribe [:search/results-total])
         per-page     (re-frame/subscribe [:search/per-page])
         max-pages 10
         npages    (Math/ceil (/ @total @per-page))
         start     (max 0 (min (- npages max-pages)
                               (- @current-page (/ max-pages 2))))
         end       (min (+ start max-pages) npages)]
     (map inc (range start end)))))
